import {
  SET_LOADING,
  SAVE_DATA,
  SET_FILTER,
  SET_ACTIVE_PAGE,
  VM_LOADING,
  BTN_LOADING,
  SET_VM_OPTIONS,
  SET_VM_SELECTED_OPTION,
} from './constants';
import { CLEAR_STATE } from '../HandleAPICalls/constants';

const initialState = {
  loading: true,
  productData: [],
  filter: '',
  activePage: 1,
  vmOptions: [],
  vmLoading: true,
  vmDefaultSelected: 'all',
  dwnBtnLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.isLoading,
      };

    case SAVE_DATA:
      return {
        ...state,
        productData: action.data,
      };

    case SET_FILTER:
      return {
        ...state,
        filter: action.filter,
      };

    case SET_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.pageNumber,
      };

    case VM_LOADING:
      return {
        ...state,
        vmLoading: action.loading,
      };

    case SET_VM_OPTIONS:
      return {
        ...state,
        vmOptions: action.options,
      };

    case SET_VM_SELECTED_OPTION:
      return {
        ...state,
        vmDefaultSelected: action.value,
      };

    case BTN_LOADING:
      return {
        ...state,
        dwnBtnLoading: action.loading,
      };

    case CLEAR_STATE:
      return initialState;

    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/Modules/ProductDetails/reducer.js